import script from "./RecentAncestryKitStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentAncestryKitStatus.vue?vue&type=script&setup=true&lang=js"

import "./RecentAncestryKitStatus.vue?vue&type=style&index=0&id=53dde142&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53dde142"]])

export default __exports__